import { createFileRoute } from "@tanstack/react-router";

import { title } from "@/components/base/primitives";
import { ResetPasswordForm } from "@/components/users/reset-password-form";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/account/reset-password")({
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    token?: string;
  } => {
    return {
      token: search.token as string,
    };
  },
  head: () => ({
    meta: [{ title: "Reset Password" }],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { token } = Route.useSearch();

  return (
    <DefaultLayout>
      <div className="mx-auto flex max-w-xl flex-col space-y-6 text-center">
        <h1 className={title({ size: "lg" })}>Reset Password</h1>
      </div>

      <ResetPasswordForm
        className="mx-auto w-full max-w-sm rounded-lg bg-white p-8"
        token={token}
      />
    </DefaultLayout>
  );
}
